module.exports = __webpack_public_path__ + "img/scratch_icon.8c9707f4.png";